export const sideNavUsp = (props?: any) => {
  return {
    type: 'PartnerContentManager',
    props: {
      descriptor: {
        type: 'Usp',
        props: {
          css: {
            width: '310px',
            padding: '0',
            paddingLeft: '25px',
            bg: 'transparent',
            boxShadow: 'none',
            marginBottom: 6,
            svg: {
              margin: 0,
            },
            div: {
              gap: '4px',
              marginBottom: '4px !important',
              alignItems: 'center',
              '> p': {
                color: 'main.2',
              },
            },
            ...props,
          },
          marginTop: 6,
          items: [
            'Met gratis opzegservice',
            '14 dagen bedenktijd',
            'Binnen 2 minuten geregeld',
          ],
          iconVerticalAlignment: 'start',
        },
      },
    },
  };
};
